/**
 * Internal dependencies
 */
import WMUUtils from "../../wmu-utils/src";
import WMUFx from "../../wmu-utils/src/fx/fx";
import ViewportManager from "./viewport-manager";

/**
 * 
 */
class BlockMenuItem {

	/**
	 * 
	 * @type String
	 */
	displayMode = '';

	/**
	 * 
	 * @type HTMLElement
	 */
	element = null;

	/**
	 * 
	 * @type WMUFx
	 */
	menuFxInstance = null;

	/**
	 * 
	 * @type Boolean
	 */
	hasMenu = false;

	/**
	 * 
	 * @type String
	 */
	hasMenuClassName = 'has-menu';

	/**
	 * 
	 * @type Boolean
	 */
	isOpen = false;

	/**
	 * 
	 * @type String
	 */
	isOpenClassName = 'is-open';

	/**
	 * 
	 * @type HTMLElement
	 */
	linkElement = null;

	/**
	 * 
	 * @type String
	 */
	linkSelector = ':scope > .menu-item-link';

	/**
	 * 
	 * @type HTMLElement
	 */
	menuInnerElement = null;

	/**
	 * 
	 * @type String
	 */
	menuInnerSelector = ':scope > .menu-inner';

	/**
	 * 
	 * @type Number
	 */
	mouseOutClosingDelay = 200;

	/**
	 * 
	 * @type Number
	 */
	mouseOutTimeoutId = null;

	/**
	 * 
	 * @type Boolean
	 */
	openOnClick = true;

	/**
	 * 
	 * @type Boolean
	 */
	openOnHover = true;

	/**
	 * 
	 * @param {HTMLElement} element 
	 */
	constructor( element )
	{
		this.element = element;
		this.element.wmuBlockMenuItem = this;

		this.hasMenu = this.element.classList.contains( this.hasMenuClassName );

		this.init();
		this.setup();
	}

	/**
	 * 
	 */
	init()
	{
		this.onClickOutside = this.onClickOutside.bind( this );
		this.onLinkClick = this.onLinkClick.bind( this );
		this.onMouseOut = this.onMouseOut.bind( this );
		this.onMouseOutTimeout = this.onMouseOutTimeout.bind( this );
		this.onMouseOver = this.onMouseOver.bind( this );

		this.linkElement = this.element.querySelector( this.linkSelector );

		if ( ! this.linkElement )
		{
			console.warn( 'No link element found', this );
		}

		if ( this.hasMenu )
		{
			this.menuInnerElement = this.element.querySelector( this.menuInnerSelector );

			if ( ! this.menuInnerElement )
			{
				console.warn( 'No menu inner element found', this );
			}
		}
	}

	/**
	 * 
	 */
	clear()
	{
		if ( this.hasMenu )
		{
			this.close();
	
			switch ( this.displayMode )
			{
				default:
				case 'dropdown':
					this.clearDisplayModeDropdown();
					break;
				
				case 'elastic':
					this.clearDisplayModeElastic();
					break;
				
				case 'expand':
					this.clearDisplayModeExpand();
					break;
				
				case 'none':
					break;
			}
		}

		this.element.wmuBlockMenuItem = undefined;
	}

	/**
	 * 
	 */
	clearDisplayModeDropdown()
	{
		if ( this.openOnClick ) this.linkElement.removeEventListener( 'click', this.onLinkClick );
		if ( this.openOnHover ) this.clearOpenOnHover();
	}

	/**
	 * 
	 */
	clearDisplayModeElastic()
	{
		this.linkElement.removeEventListener( 'click', this.onLinkClick );
		WMUUtils.clearFxInstance( this.menuInnerElement, 'expand-collapse' );
	}

	/**
	 * 
	 */
	clearDisplayModeExpand()
	{
		if ( this.openOnClick ) this.linkElement.removeEventListener( 'click', this.onLinkClick );
		if ( this.openOnHover ) this.clearOpenOnHover();
	}

	/**
	 * 
	 */
	clearOpenOnHover()
	{
		this.element.removeEventListener( 'mouseover', this.onMouseOver );
		this.element.removeEventListener( 'mouseout', this.onMouseOut );
	}

	/**
	 * 
	 */
	setup()
	{
		if ( this.hasMenu )
		{
			const viewportCurrent = ViewportManager.getCurrentViewport();
			this.displayMode = this.element.getAttribute( `${viewportCurrent}-menu-display` );
			this.openOnClick = ( '0' === this.element.getAttribute( `${viewportCurrent}-open-on-click` ) ) ? false : true;
			this.openOnHover = ( '0' === this.element.getAttribute( `${viewportCurrent}-open-on-hover` ) ) ? false : true;

			if ( ! this.displayMode )
			{
				switch ( viewportCurrent )
				{
					default:
					case 'vl':
					case 'vxl':
						this.displayMode = 'dropdown';
						break;
					
					case 'vs':
					case 'vm':
						this.displayMode = 'elastic';
						break;
				}
			}

			switch ( this.displayMode )
			{
				default:
				case 'dropdown':
					this.setupDisplayModeDropdown();
					break;
				
				case 'elastic':
					this.setupDisplayModeElastic();
					break;
				
				case 'expand':
					this.setupDisplayModeExpand();
					break;
				
				case 'none':
					break;
			}
		}
	}

	/**
	 * 
	 */
	setupDisplayModeDropdown()
	{
		if ( this.openOnClick ) this.linkElement.addEventListener( 'click', this.onLinkClick );
		if ( this.openOnHover ) this.setupOpenOnHover();
	}

	/**
	 * 
	 */
	setupDisplayModeElastic()
	{
		if ( this.openOnClick ) this.linkElement.addEventListener( 'click', this.onLinkClick );
		this.menuFxInstance = WMUUtils.fxInstance( this.menuInnerElement, 'expand-collapse', { initState: 'collapse' } );
	}

	/**
	 * 
	 */
	setupDisplayModeExpand()
	{
		if ( this.openOnClick ) this.linkElement.addEventListener( 'click', this.onLinkClick );
		if ( this.openOnHover ) this.setupOpenOnHover();
	}

	/**
	 * 
	 */
	setupOpenOnHover()
	{
		this.element.addEventListener( 'mouseover', this.onMouseOver );
		this.element.addEventListener( 'mouseout', this.onMouseOut );
	}

	/**
	 * 
	 */
	close()
	{
		this.element.classList.remove( this.isOpenClassName );
		this.isOpen = false;
		
		document.removeEventListener( 'click', this.onClickOutside );

		switch ( this.displayMode )
		{
			case 'elastic':
				this.menuFxInstance.start( 'collapse' );
				break;
		}
	}

	/**
	 * 
	 */
	open()
	{
		this.element.classList.add( this.isOpenClassName );
		this.isOpen = true;
		
		document.addEventListener( 'click', this.onClickOutside );

		switch ( this.displayMode )
		{
			case 'elastic':
				this.menuFxInstance.start( 'expand' );
				break;
		}
	}

	/**
	 * 
	 */
	toggleOpen()
	{
		if ( this.isOpen )
		{
			this.close();
		}
		else
		{
			this.open();
		}
	}
	
	/**
	 * 
	 * @param {Event} event 
	 */
	onClickOutside( event )
	{
		if ( ! this.isOpen || this.element.contains( event.target ) )
		{
			return;
		}

		this.close();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onMouseOut( event )
	{
		if ( null !== this.mouseOutTimeoutId )
		{
			clearTimeout( this.mouseOutTimeoutId );
			this.mouseOutTimeoutId = null;
		}

		this.mouseOutTimeoutId = setTimeout( this.onMouseOutTimeout, this.mouseOutClosingDelay );
	}

	/**
	 * 
	 */
	onMouseOutTimeout()
	{
		this.close();
		this.mouseOutTimeoutId = null;
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onMouseOver( event )
	{
		if ( null !== this.mouseOutTimeoutId )
		{
			clearTimeout( this.mouseOutTimeoutId );
			this.mouseOutTimeoutId = null;
		}

		this.open();
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onLinkClick( event )
	{
		event.preventDefault();
		this.toggleOpen();
	}

}

export default BlockMenuItem;